/**
 * The configured API client for the web app.
 *
 * Firebase tokens are injected here; `@chordbookpro/api-client` stays free of any
 * auth SDK so the same package works unchanged on mobile.
 */

import { createChordBookProApi } from '@chordbookpro/api-client';
import { apiUrl } from '../config/appConfig.js';
import { getIdToken } from './firebase.js';

let onUnauthenticated = null;

/** Registers a callback for when the session becomes invalid. */
export function setUnauthenticatedHandler(handler) {
  onUnauthenticated = handler;
}

export const { http, api } = createChordBookProApi({
  baseURL: apiUrl,
  clientName: 'web',
  // Injected by Vite from apps/web/package.json. The API never gates the web
  // client — a browser always runs the bundle it was just served — but the
  // header is used for server-side logging, so it should be true.
  clientVersion: __APP_VERSION__,
  getAuthToken: () => getIdToken(false),
  refreshAuthToken: () => getIdToken(true),
  onAuthError: (error) => onUnauthenticated?.(error),
});
